export default __webpack_public_path__ + "static/media/avatar-s-16.1850b51c.jpg";